function getPayPalTopLevelDomain(fqdn='') {
    const re = /\.(paypal\.[a-z\.]+)$/i.exec(fqdn);
    return re && re[1] || undefined;
}

function getCurrentStage(defaultStage='msmaster.qa.paypal.com') {
    // use testenv's instance.fqdn, as the recommendation is that other services should be accessed through the testenv's FQDN
    const fqdn = process.env.instance_fqdn;
    // non msmaster staging environment has support for different backing environments and top-level domains
    // this also verifies fqdn value
    const domain = fqdn && getPayPalTopLevelDomain(fqdn);
    if (domain) {
        return [ fqdn, domain ];
    } else {
         // instance_fqdn is not set, or it potentially has invalid value
        return [ defaultStage ];
    }
}

module.exports = {
    getCurrentStage
};
